import { styled, Tab, Tabs } from "@mui/material";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

function BaseTabPanel({ list, labels, tabValue, handleTabChange, isError }) {
    //general variables
    const { t } = useTranslation();
    const tabRef = useRef();

    //tab styles
    const StyledTab = styled(props => <Tab disableRipple {...props} />)(({ theme }) => ({
        minHeight: "2.5rem",
        marginRight: theme.spacing(1),
        color: "var(--gray-color)",
        border: "1px solid var(--gray-color)",
        borderRadius: "0.625rem",
        "&.Mui-selected": {
            color: isError ? "var(--red-color)" : "var(--primary-color)",
            backgroundColor: isError ? "var(--red-color-20)" : "var(--primary-color-20)",
            border: isError ? "1px solid var(--red-color)" : "1px solid var(--primary-color)",
            borderRadius: "0.625rem",
        },
    }));

    return (
        <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons={false}
            indicatorColor="transpatent"
            ref={tabRef}
            sx={{
                position: "fixed",
                width: "100%",
                left: "0",
                right: "0",
                bottom: "130px",
                boxSizing: "border-box",
                padding: "16px 10px",
                backgroundColor: "var(--light-color)",
                boxShadow: "0px px 4px 0px rgba(0, 0, 0, 0.25)",
                zIndex: "2",
            }}
        >
            {list?.map((_, index) => {
                return <StyledTab key={index} label={labels ? t(`${labels?.[index]}`) : `${t("room")}  ${index + 1}`} />;
            })}
        </Tabs>
    );
}

export default BaseTabPanel;
